import { Link } from 'react-router-dom';
import React from 'react';

export const MarketplaceHomePageLink = () => {
  return (
    <Link to="/" style={{ height: '32px' }}>
      <img
        src="/pv-logo-marketplace.png"
        alt="Perfect Venue Logo"
        height={'32px'}
      />
    </Link>
  );
};
